"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadingCellFactory = void 0;
var _react = _interopRequireDefault(require("react"));
var _loadingCellModule = _interopRequireDefault(require("./loading-cell.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var loadingCellFactory = function loadingCellFactory(baseClassName) {
  var LoadingCell = function LoadingCell(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/_react.default.createElement("td", {
      className: (0, _classnames.default)(_loadingCellModule.default['loading-cell'], baseClassName, className),
      "data-testid": "loading-cell"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _loadingCellModule.default['loading-cell__skeleton']
    }));
  };
  return LoadingCell;
};
exports.loadingCellFactory = loadingCellFactory;